import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { SrcNotificationSetting } from '../../../projects/client/apis/src-notification-settings/src-notification-settings.model';

import { SrcNotificationSettingsActions } from './src-notification-settings.actions';
import { SrcNotificationSettingsSelectors } from './src-notification-settings.selectors';

@Injectable({ providedIn: 'root' })
export class SrcNotificationSettingsStore {
  data$: Observable<SrcNotificationSetting | null> = this.store.select(
    SrcNotificationSettingsSelectors.selectData
  );

  isEnabled$: Observable<boolean> = this.store.select(
    SrcNotificationSettingsSelectors.selectIsEnabled
  );

  threshold$: Observable<string> = this.store.select(
    SrcNotificationSettingsSelectors.selectThreshold
  );

  loading$: Observable<boolean> = this.store.select(SrcNotificationSettingsSelectors.selectLoading);

  loaded$: Observable<boolean> = this.store.select(SrcNotificationSettingsSelectors.selectLoaded);

  constructor(private readonly store: Store) {}

  get(installationId: number): void {
    this.store.dispatch(
      SrcNotificationSettingsActions.getNotificationSettings.attempt({ installationId })
    );
  }

  set(installationId: number, isEnabled: boolean, threshold: string): void {
    this.store.dispatch(
      SrcNotificationSettingsActions.setNotificationSettings.attempt({
        installationId,
        isEnabled,
        threshold,
      })
    );
  }
}
